import ModalAddOrUpdateCertification from "./ModalAddOrUpdateCertification.js";
import ModalDeleteCertification from "./ModalDeleteCertification.js";

export { ModalAddOrUpdateCertification, ModalDeleteCertification };
